<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>Kişisel Ayarlarım</h1>
          </div>
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">Kişisel Ayarlarım</a></li>
          </ul>
        </div>
        <div class="row form-margin">
          <div class="col-md-12 tex-center d-flex align-items-center flex-column">
            <div class="tile">
              <h3 class="tile-title">Kişisel Ayarlarım</h3>
              <div>
                <div
                  class="card-body tex-center d-flex align-items-center flex-column"
                >
                  <img
                    style="margin-left: auto; margin-right: auto;margin-bottom:12px"
                    id="profile-container"
                    :src="
                      product.selectedImage == null
                        ? this.result.imgSrc + this.result.img_url
                        : product.selectedImage
                    "
                  />
                  <input
                    ref="file"
                    type="file"
                    style="display: none;"
                    @change="onChange($event)"
                    class="form-control"
                  />
                  <button
                    class="btn btn-outline-secondary "
                    type="button"
                    @click="$refs.file.click()"
                  >
                    Resim Seç
                  </button>
                </div>
              </div>
  
              <div class="tile-body">
                <form>
                  <div class="form-group">
                    <label class="control-label">Adı:</label>
                    <input
                      v-model="result.firstname"
                      class="form-control"
                      type="text"
                      placeholder="Kullanıcı Adını Giriniz"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Soyadı:</label>
                    <input
                      v-model="result.lastname"
                      class="form-control"
                      type="text"
                      placeholder="Kullanıcı Adını Giriniz"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Email:</label>
                    <input
                      v-model="result.email"
                      class="form-control"
                      type="email"
                      placeholder="Email Adresinizi Giriniz"
                    />
                  </div>
                  <div class="row">
                    <div class="col-md-12 offset-md-12">
                      <form
                        action="page2.php"
                        id="myForm1"
                        class="needs-validation"
                        novalidate
                      >
                        <div class="form-group">
                          Parola(Yeni Şifrenizi Veya Varsayılan Şifrenizi Giriniz):<input
                            v-model="result.password"
                            type="password"
                            id="pwdId"
                            class="form-control"
                            pattern="^[a-z]{2,4}$"
                            required
                            placeholder="Şifrenizi Giriniz"
                          />
                          <p style="color: red">{{ warnPass }}</p>
                          <div class="valid-feedback">Şifreler Uyuşuyor</div>
                          <div class="invalid-feedback">
                            a to z only (2 to 4 long)
                          </div>
                        </div>
                        <div class="form-group">
                          Parola:<input
                            v-model="result.passValid"
                            type="password"
                            id="cPwdId"
                            class="form-control"
                            pattern="^[a-z]{2,4}$"
                            required
                            placeholder="Şifrenizi Tekrar Giriniz"
                          />
                          <p style="color: red">{{ warnPassValid }}</p>
                          <div id="cPwdValid" class="valid-feedback">
                            Şifreler Uyuşuyor
                          </div>
                          <div id="cPwdInvalid" class="invalid-feedback">
                            a to z only (2 to 4 long)
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </form>
              </div>
  
              <div class="tile-footer">
                <button
                  @click="uploadFile()"
                  class="btn btn-primary"
                  type="button"
                >
                  <i class="fa fa-fw fa-lg fa-check-circle"></i>Güncelle
                </button>
  
                <button
                  @click="reload()"
                  class="btn fileupload-exists"
                  data-dismiss="fileupload"
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  export default {
    data() {
      return {
        result: {
          firstname: "",
          lastname: "",
          email: "",
          phone: "",
          tc_number: "",
          password: "",
          passValid: "",
          img_url: "",
          unvan: "",
          imgSrc: store.state.img_base_url,
        },
        warnPass: "",
        warnPassValid: "",
        file: "",
        fileWarn: "",
        product: {
          selectedImage: null,
        },
      };
    },
    methods: {
      onChange(e) {
        const file = e.target.files[0];
        this.product.selectedImage = URL.createObjectURL(file);
      },
  
      reload: function() {
        location.reload();
      },
  
      uploadFile: function() {
        this.file = this.$refs.file.files[0];
        if (!this.$refs.file.files[0]) {
          return this.sendData();
        }
        var result = this.result;
        var sendData = this.sendData;
        if (this.file.size > 2500000) {
          this.fileWarn =
            "Yükleyeceğiniz Dosya Boyutu 2.5 Mb'yi Aşamaz!  " +
            " Dosya Boyutunuz : " +
            this.file.size / 1000000 +
            "Mb";
          //console.log("dosya boyutu büyük");
          return;
        }
        let formData = new FormData();
        formData.append("file", this.file);
        var admin_token = localStorage.getItem("admin_token");
        var query = store.state.img_upload_urlAdminpp + "?admin_token=" + admin_token;
        axios
          .post(query, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(function(response) {
            //console.log(response);
            if (response.data.result) {
              //console.log("işlem başarılı");
                result.img_url = response.data.data;
                sendData();
            } else {
              //console.log("işlem başarısız");
            }
          })
          .catch(function(error) {
            //console.log(error);
          });
      },
      sendData: function() {
        var url = store.state.base_url + "Admin/updateByMyIdAdmin.php?key=123";
  
        var datas = {
          id: localStorage.getItem("id"),
          admin_token: localStorage.getItem("admin_token"),
          name: this.result.firstname,
          surname: this.result.lastname,
          email: this.result.email,
          password: this.result.password,
          img_url: this.result.img_url,
        };
  
        if (this.result.passValid != this.result.password) {
          this.warnPassValid = "parolalar eşleşmiyor";
          return false;
        }
        if (this.result.passValid == "" || this.result.password == "") {
          this.warnPass = "lütfen parolayı boş bırakmayınız";
          return false;
        }
  
        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data.data == true) {
             this.$swal({
              text: "Profil Başarıyla Güncellendi!",
              icon: "success",
              closeOnClickOutside: true,
            });
            location.reload();

            }
  
            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      },
    },
  
    mounted() {
      var url = store.state.base_url + "Admin/getByMyIdAdmin.php?key=123";
      var datas2 = {
        id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("admin_token"),
      };
  
      axios
        .post(url, JSON.stringify(datas2))
        .then((response) => {
          datas2 = response.data.data;
          this.result.firstname = datas2.name;
          this.result.lastname = datas2.surname;
          this.result.email = datas2.email;
          console.log(datas2.img_url)
          if (datas2.img_url == false) {
            this.result.img_url = "man-in-suit-and-tie.svg";
          } else {
            this.result.img_url = datas2.img_url;
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
  
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/AdminPersonalSettings.vue